import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classes from './DragAndDropFiles.module.css'
import { formatDate } from '../../../../../lib/script'
import { rejectOversizedBoxUploadFiles } from '../../../../../lib/docs'
import { notificationActions } from '../../../../../store/notifications'

export default function DragAndDropFilesProco({removeFiles, uploadfile}) {
    const wrapperRef = useRef(null)
    const dispatch = useDispatch()

    const user = useSelector(state => state.user.user)

    const onFileDrop = (e) => {
        if (e.target.files.length > 0) {
            const { accepted, rejectedMessage } = rejectOversizedBoxUploadFiles(e.target.files)
            if (rejectedMessage) {
                dispatch(notificationActions.setError({ errorMessage: rejectedMessage }))
            }
            if (accepted.length === 0) {
                e.target.value = ''
                return
            }

            let filesArray = accepted.map(item => {
                return {
                    id: Math.random(),
                    file: item.name,
                    file_to_upload: item,
                    dateuploaded: formatDate(new Date()),
                    uploader: user.name,
                    type: null,
                    notes: null
                }
            })
            uploadfile(filesArray)
            removeFiles()
        }

	}


    return <div className={classes.container} ref={wrapperRef}>
        <input type="file" value="" onChange={onFileDrop} multiple />        
        <div className={classes.icon}>
            <i className='ti ti-upload'></i>
            <p>Drop your files here</p>
        </div>
    </div>
}
